import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconPromo = (props) => {
  props = Object.assign({viewBox: '0 0 36 36'}, props);
  return (
    <SvgIcon {...props}>
      <path d="M33.4,14.5c-0.2-0.5-0.6-0.8-1.1-0.8H22.2l-3.1-9.3c-0.2-0.5-0.6-0.8-1.1-0.8h0c-0.5,0-1,0.3-1.1,0.8
			l-3.1,9.3h-10c-0.5,0-1,0.3-1.1,0.8c-0.2,0.5,0,1,0.4,1.3l8.1,5.8l-3.1,9.3c-0.2,0.5,0,1,0.4,1.3c0.2,0.2,0.5,0.2,0.7,0.2
			c0.2,0,0.5-0.1,0.7-0.2l8.1-5.7l8.1,5.7c0.2,0.1,0.5,0.2,0.7,0.2c0.2,0,0.5-0.1,0.7-0.2c0.4-0.3,0.6-0.8,0.4-1.3l-3.1-9.3l8.1-5.8
			C33.4,15.5,33.5,15,33.4,14.5z M23.8,20.9c-0.2,0.2-0.3,0.4-0.2,0.7l3.2,9.7l-8.4-6c-0.1-0.1-0.2-0.1-0.3-0.1
			c-0.1,0-0.2,0-0.3,0.1l-8.4,6l3.2-9.7c0.1-0.2,0-0.5-0.2-0.7l-8.4-6h10.4c0.3,0,0.5-0.2,0.6-0.4l3.2-9.7l3.2,9.7
			c0.1,0.2,0.3,0.4,0.6,0.4h10.5L23.8,20.9z"/>
    </SvgIcon>
  );
};

IconPromo.displayName = 'IconPromo';
IconPromo.muiName = 'SvgIcon';

export default IconPromo;



// WEBPACK FOOTER //
// ./src/components/Icons/IconPromo.js